import { ListFilter, SortDirection } from "@common/api/filterTypes";
import { DataControllerRecordModel } from "../DataControllerRecord/DataControllerRecord.types";

export enum ProcessingActivityRecordType {
    DataController = 1,
    ExtendedDataController = 2,
    DataProcessor = 3,
}

// The data controller record's columns that hold a single text and so can be sorted on. Mirrors the backend enum.
export enum DataControllerRecordColumn {
    Name = 1,
    Purposes = 2,
    BusinessAreas = 3,
    SecurityMeasures = 4,
    Systems = 5,
}

// The paging and the sort are left out of a view's changed-comparison by usePageView.
export interface ProcessingActivityRecordFilterData {
    recordType?: ProcessingActivityRecordType;
    groupEntityIds?: ListFilter<string>;
    showOnlyMine?: boolean;
    processingActivityIds?: ListFilter<string>;
    businessAreaIds?: ListFilter<string>;
    pageNumber?: number;
    sortByColumn?: DataControllerRecordColumn;
    sortDirection?: SortDirection;
}

export interface DataControllerRecordFilterRequest {
    groupEntityId: string;
    showOnlyMine: boolean;
    processingActivityIds?: ListFilter<string>;
    businessAreaIds?: ListFilter<string>;
    isExtended: boolean;
    searchText?: string;
    pageNumber: number;
    pageSize: number;
    sortByColumn?: DataControllerRecordColumn;
    sortDirection?: SortDirection;
}

export interface DataControllerRecordSearchResult {
    rows: Array<DataControllerRecordModel>;
    totalCount: number;
    totalPages: number;
}
